import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  ArrowBackIos,
  Save,
  Settings,
  Troubleshoot
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { Header } from '../../../components/header/header';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import Strings from '../../../i18n';
import { ButtonIconStyled } from '../../devices/devicesStyles';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../components/layout/main/mainStyles';
import { SportUserPreferences } from '../../../templates/applications/sports/teamPreference/teamPreference';

export const SportsView = () => {
  const navigate = useNavigate();
  const [openSideBar, setOpenSideBar] = useState(false);
  const { locationId } = useParams();
  const [selectedSportPreferences, setSelectedSportPreferences] = useState<
    any[]
  >([]);
  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.empty
  );

  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };

  const reloadTable = () => {
    setSelectedSportPreferences([]);
  };

  const closeSideBar = () => {
    setOpenSideBar(false);
    setSelectedSportPreferences([]);
  };

  const closeWithoutClear = () => {
    setOpenSideBar(false);
  };

  useEffect(() => {
    if (selectedSportPreferences.length === 1) {
      openRightSideBarForMethod(viewRightSideBarEnum.empty);
    } else if (selectedSportPreferences.length > 1) {
      openRightSideBarForMethod(viewRightSideBarEnum.empty);
      setOpenSideBar(false);
    } else {
      openRightSideBarForMethod(viewRightSideBarEnum.empty);
      setOpenSideBar(false);
    }
  }, [selectedSportPreferences]);

  const switchComponentToShowRightSideBar = () => {
    switch (sideBarOpenFor) {
      case viewRightSideBarEnum.empty:
        return <p>qsdasdsad</p>;
      default:
        return <p />;
    }
  };
  return (
    <>
      <div>
        <Header>
          <StyledHeaderContainer>
            <div className="row justify-content-between">
              <div className="col-4 text-left">
                <ButtonIconStyled
                  size="small"
                  onClick={() =>
                    navigate(`/locations/${locationId}/applications`)
                  }
                >
                  <ArrowBackIos />
                </ButtonIconStyled>
              </div>
              <div className="col-4 text-center">
                <StyledTitleHeader>
                  {Strings.sports.sportPreferences}
                </StyledTitleHeader>
              </div>
              <div className="col-4 text-right">
                <Tooltip title={Strings.sports.addTeam}>
                  <ButtonIconStyled
                    size="small"
                    onClick={() =>
                      navigate(
                        `/locations/${locationId}/applications/game_day/add`
                      )
                    }
                  >
                    <AddCircleOutlineIcon />
                  </ButtonIconStyled>
                </Tooltip>
                <Tooltip title={Strings.sports.sportSettings}>
                  <ButtonIconStyled
                    size="small"
                    onClick={() =>
                      navigate(
                        `/locations/${locationId}/applications/game_day/sportsSettings`
                      )
                    }
                  >
                    <Settings />
                  </ButtonIconStyled>
                </Tooltip>
                <Tooltip title={Strings.sports.sportTroubleshooting}>
                  <ButtonIconStyled
                    size="small"
                    onClick={() =>
                      navigate(
                        `/locations/${locationId}/applications/game_day/sport-troubleshooting`
                      )
                    }
                  >
                    <Troubleshoot />
                  </ButtonIconStyled>
                </Tooltip>
              </div>
            </div>
          </StyledHeaderContainer>
        </Header>
        <SportUserPreferences />
      </div>
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          closeSideBar();
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
